import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Magento.svg",
  "use": "Magento.svg-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"Magento.svg\">\n<path d=\"M12 4L5 8.24271V15.7573L6.8617 16.836V9.28539L12 6.15729L17.1383 9.28539V16.836L19 15.7573V8.24271L12 4Z\" />\n<path d=\"M13.117 17.6629L12 18.3101L10.883 17.6629V8.92584L8.76064 10.1843V18.0225L12 20L15.2394 18.0225V10.1843L13.117 8.92584V17.6629Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol